import React, { useState, useEffect } from 'react';

interface ResolutionDisplayProps {
  className?: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}

export const ResolutionDisplay: React.FC<ResolutionDisplayProps> = ({ 
  className = '',
  position = 'top-right'
}) => {
  const [dimensions, setDimensions] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0
  });

  // 监听窗口大小变化
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleResize = () => {
      setDimensions({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 获取屏幕类型标识
  const getScreenIcon = () => {
    const { width } = dimensions;
    if (width >= 2560) return '🖥️'; // 4K
    if (width >= 1920) return '💻'; // 桌面
    if (width >= 1366) return '🖱️'; // 笔记本
    if (width >= 1024) return '📱'; // 平板
    return '📱'; // 手机
  };

  // 位置样式
  const positionClasses = {
    'top-left': 'top-4 left-4',
    'top-right': 'top-4 right-4',
    'bottom-left': 'bottom-4 left-4',
    'bottom-right': 'bottom-4 right-4'
  };

  return (
    <div 
      className={`fixed ${positionClasses[position]} z-50 ${className}`}
    >
      <div className="bg-black bg-opacity-70 text-white px-2 py-1 rounded text-xs font-mono backdrop-blur-sm">
        {getScreenIcon()} {dimensions.width}×{dimensions.height}
      </div>
    </div>
  );
};
